import { useContext } from 'react';

import { GroupContext } from './groupContextContext';

export const useGroupContext = () => {
    const context = useContext(GroupContext);

    if (!context) {
        throw new Error('useGroupContext must be used within GroupContextProvider');
    }

    return context;
};
